import classes from './publisherDashboard.module.css';

export default function Documentation() {
    return (
        <div className={classes.documentationContainer}>
            <h2>Integration Documentation</h2>
            
            <section className={classes.docSection}>
                <h3>1. Offerwall Integration</h3>
                <p>To integrate the offerwall into your application, add the following iframe to your webpage:</p>
                <pre className={classes.codeBlock}>
{`<iframe
    src="https://offerwall.rewardrocket.app/{PUBLISHER_ID}/{PLACEMENT_ID}/{YOUR_USER_ID}"
    width="100%"
    height="800"
    frameborder="0"
></iframe>`}
                </pre>
                <p>Your actual iframe URL can be found in your placement settings.</p>
            </section>

            <section className={classes.docSection}>
                <h3>2. Postback URL Setup</h3>
                <p>Configure your postback URL in the placement settings to receive conversion notifications. The system will send POST requests to your URL with the following parameters:</p>
                <pre className={classes.codeBlock}>
{`{
    "userID": "your_user_id",
    "transactionID": "unique_transaction_id",
    "ip": "user_ip_address",
    "revenue": "revenue_in_usd",
    "amount": "currency_amount_for_user"
}`}
                </pre>
                <p>Your server should respond with a 200 status code to acknowledge receipt of the postback.</p>
            </section>

            <section className={classes.docSection}>
                <h3>3. API Integration</h3>
                <h4>Get Available Offers</h4>
                <pre className={classes.codeBlock}>
{`GET https://api.cashoutnow.com/offers
Query Parameters:
    api_key: YOUR_API_KEY
    publisher_id: YOUR_PUBLISHER_ID
    user_id: USER_ID
    countries: ["US"] (optional)
    quantity_limit: 40 (optional)

Response:
{
    "offers": [
        {
            "id": "offer_id",
            "title": "Offer Title",
            "description": "Offer Description",
            "devices": ["android", "iphone"],
            "imageUrl": "offer_image_url",
            "click_url": "offer_click_url",
            "reward": "offer_reward_amount",
            "events": [
                {
                    "eventDescription": "Task Description",
                    "value": "reward_value"
                }
            ],
            "conversion_rate": "offer_conversion_rate"
        }
    ]
}`}
                </pre>
            </section>

            <section className={classes.docSection}>
                <h3>4. Best Practices</h3>
                <ul>
                    <li>Always validate the postback data on your server</li>
                    <li>Implement proper error handling for API requests</li>
                    <li>Store the API key securely and never expose it in client-side code</li>
                    <li>Use HTTPS for all API communications</li>
                    <li>Implement rate limiting on your postback endpoint</li>
                </ul>
            </section>
        </div>
    );
} 